// The Passport Journal content registry.
// Owner-supplied/approved content populates this array. Empty until approved content exists,
// so the Journal stays hidden from primary navigation and is noindexed.
// Each item: { slug, title, type, category, cover, excerpt, date, readTime, content: [blocks] }
// block types: {t:'p'|'h2'|'quote', text} | {t:'img', src, alt} | {t:'audio', src} | {t:'video', src}
export const JOURNAL = [];

export const JOURNAL_CATEGORIES = ["Group Travel", "Cruises", "Resorts & Escapes", "Destinations", "Travel Tips", "Weddings & Celebrations", "Honeymoons", "Travel Stories"];
